/* ============================================================
   Hug Ring — theme.js
   Cart drawer, mobile nav, free-ship bar, AJAX cart
   ============================================================ */
(function(){
  'use strict';

  const $ = (s, ctx = document) => ctx.querySelector(s);
  const $$ = (s, ctx = document) => Array.from(ctx.querySelectorAll(s));

  // ------- Cart store -------
  const CartStore = {
    state: null,
    listeners: new Set(),
    subscribe(fn){ this.listeners.add(fn); return () => this.listeners.delete(fn); },
    emit(){ this.listeners.forEach(fn => fn(this.state)); },
    async fetch(){
      const r = await fetch('/cart.js');
      this.state = await r.json();
      this.emit();
      return this.state;
    },
    async add(formData){
      const r = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } });
      if (!r.ok) { const err = await r.json(); throw err; }
      const item = await r.json();
      await this.fetch();
      return item;
    },
    async change(line, quantity){
      const r = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity }) });
      this.state = await r.json();
      this.emit();
      return this.state;
    }
  };
  window.CartStore = CartStore;

  // ------- Formatter -------
  const moneyFormat = window.Shopify && Shopify.shop ? null : null;
  function formatMoney(cents){
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }
  window.formatMoney = formatMoney;

  // ------- Mobile nav -------
  document.addEventListener('click', e => {
    const toggle = e.target.closest('[data-mnav-toggle]');
    if (toggle) {
      $('.m-nav')?.classList.toggle('is-on');
      return;
    }
    if (e.target.matches('.m-nav') || e.target.closest('[data-mnav-close]')) {
      $('.m-nav')?.classList.remove('is-on');
    }
  });

  // ------- Cart drawer toggle -------
  function openCart(){ $('.cart-drawer')?.classList.add('is-on'); document.body.style.overflow = 'hidden'; }
  function closeCart(){ $('.cart-drawer')?.classList.remove('is-on'); document.body.style.overflow = ''; }
  window.openCart = openCart;
  window.closeCart = closeCart;
  document.addEventListener('click', e => {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); }
    if (e.target.matches('.cart-drawer__backdrop') || e.target.closest('[data-cart-close]')) closeCart();
  });

  // ------- Render cart drawer -------
  const drawerItems = () => $('[data-cart-drawer-items]');
  const drawerSubtotal = () => $('[data-cart-drawer-subtotal]');
  const drawerCount = () => $$('[data-cart-count]');
  const freeShipBar = () => $('[data-free-ship-bar]');
  const freeShipMsg = () => $('[data-free-ship-msg]');

  const FREE_SHIP_THRESHOLD_CENTS = (window.theme && window.theme.freeShipThreshold) || 20000; // 200 PLN default

  function renderCart(state){
    if (!state) return;
    drawerCount().forEach(el => el.setAttribute('data-count', state.item_count));
    const items = drawerItems();
    if (items) {
      if (!state.items.length) {
        items.innerHTML = '<div class="cart-empty">Twój koszyk jest pusty.</div>';
      } else {
        items.innerHTML = state.items.map((it, i) => `
          <div class="cart-item" data-line="${i+1}">
            <img src="${it.image ? it.image.replace(/\.(jpg|png|webp)$/i, '_120x.$1') : ''}" alt="${it.product_title}">
            <div class="cart-item__body">
              <h4 class="cart-item__title">${it.product_title}</h4>
              ${it.variant_title && it.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${it.variant_title}</div>` : ''}
              <div class="cart-item__price">${formatMoney(it.final_line_price)}</div>
              <div class="cart-item__qty">
                <button type="button" data-qty="-1">−</button>
                <input type="number" value="${it.quantity}" min="0" data-qty-input>
                <button type="button" data-qty="1">+</button>
              </div>
              <button class="cart-item__remove" data-remove>Usuń</button>
            </div>
          </div>`).join('');
      }
    }
    if (drawerSubtotal()) drawerSubtotal().textContent = formatMoney(state.total_price);
    // Free shipping bar
    const bar = freeShipBar(), msg = freeShipMsg();
    if (bar && msg) {
      const remaining = Math.max(0, FREE_SHIP_THRESHOLD_CENTS - state.total_price);
      const pct = Math.min(100, (state.total_price / FREE_SHIP_THRESHOLD_CENTS) * 100);
      bar.style.width = pct + '%';
      msg.textContent = remaining === 0 ? 'Masz darmową wysyłkę!' : `Brakuje ${formatMoney(remaining)} do darmowej wysyłki`;
    }
  }
  CartStore.subscribe(renderCart);

  // ------- Cart drawer line actions -------
  document.addEventListener('click', e => {
    const item = e.target.closest('.cart-item');
    if (!item) return;
    const line = parseInt(item.getAttribute('data-line'), 10);
    if (e.target.closest('[data-remove]')) {
      CartStore.change(line, 0);
    } else if (e.target.matches('[data-qty]')) {
      const delta = parseInt(e.target.getAttribute('data-qty'), 10);
      const input = item.querySelector('[data-qty-input]');
      const next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
      CartStore.change(line, next);
    }
  });
  document.addEventListener('change', e => {
    if (e.target.matches('[data-qty-input]')) {
      const item = e.target.closest('.cart-item');
      const line = parseInt(item.getAttribute('data-line'), 10);
      CartStore.change(line, Math.max(0, parseInt(e.target.value, 10) || 0));
    }
  });

  // ------- Generic product form AJAX -------
  document.addEventListener('submit', e => {
    const form = e.target.closest('form[action$="/cart/add"], form[action="/cart/add"]');
    if (!form || form.hasAttribute('data-no-ajax')) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; }
    const fd = new FormData(form);
    CartStore.add(fd).then(() => {
      openCart();
      if (btn) { btn.textContent = '✓ Dodano'; setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1200); }
    }).catch(err => {
      if (btn) { btn.disabled = false; }
      alert(err && err.description ? err.description : 'Nie udało się dodać do koszyka');
    });
  });

  // ------- Initial cart fetch -------
  document.addEventListener('DOMContentLoaded', () => CartStore.fetch());

})();
